/**
 * The IANA time zone to show times in: the signed-in user's profile zone
 * when set and valid, else the browser's, else UTC.
 */

import { useMemo } from 'react'

import { useMe } from '@/features/me/use-me'

const isValidTimeZone = (zone: string): boolean => {
  try {
    new Intl.DateTimeFormat('en', { timeZone: zone })
    return true
  } catch {
    return false
  }
}

const browserTimeZone = (): string => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
  } catch {
    return 'UTC'
  }
}

export function resolveViewerTimeZone(profileZone: string | null | undefined): string {
  if (profileZone && isValidTimeZone(profileZone)) return profileZone
  return browserTimeZone()
}

export function useViewerTimeZone(): string {
  const me = useMe()
  const profileZone = me.data?.user.timezone
  return useMemo(() => resolveViewerTimeZone(profileZone), [profileZone])
}
